export default __webpack_public_path__ + "static/media/landscape18.c7cc5578.jpeg";